<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-top">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/icon-books.svg" width="50" alt="Minds" class="">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">

        <div class="container align-items-center mobileWrap">
          <h2 class="animation-top animation-delay-02"><strong> {{ (book.title || '').toUpperCase() }}</strong></h2>
          <div class="margin-left-10 margin-right-10 container aling-items-end animation-top animation-delay-04 mobileAdjust">
            <button style="color: rgb(196, 0, 60);" class="btn btn-sm btn-rounded gradient-yellow btn-padding mobileAdjust" @click="$router.go(-1)">Voltar</button>
          </div>
        </div>

      </div>
    </div>

    <div class="shadow-box box-content-border margin-bottom-10 width-full">
      <VBViewer
        ref="vb-viewer"
        :pages="pages || []"
        :goBack="() => $router.go(-1)"
        @answer="answerQuestion"
      />
    </div>
  </div>
</template>

<script type="text/javascript">
import { cloneDeep } from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import { toArray } from '@/store/firebase'
import VBViewer from '@/components/VirtualBookViewer'

export default {
  computed: {
    ...mapGetters({
      book: 'virtualBook/getBook',
      hasBook: 'virtualBook/hasBook',
      pages: 'virtualBook/getPages',
    }),
  },
  components: {
    VBViewer,
  },
  methods: {
    ...mapMutations({
      setShowLoader: 'setShowLoader',
      setFinished: 'speakup/setFinished',
    }),
    ...mapActions({
      getBook: 'virtualBook/getBook',
    }),
    answerQuestion (payload) {
      this.$store.dispatch('virtualBook/answerQuestion', {
        book_id: this.$route.params.book,
        ...payload
      })
    }
  },
  async mounted () {
    try {
      this.setShowLoader(true)

      await this.getBook(this.$route.params.book)

      if (!this.hasBook) {
        this.setShowLoader(false)
        this.$router.replace('/virtual-books')
        return
      }

      this.setShowLoader(false)
    } catch (error) {
      console.log(error)
      this.setShowLoader(false)
      this.$router.replace('/virtual-books')
    }
  },
}
</script>

<style lang="scss">
@import './src/assets/css/components/_unitChallenge';

.mobileWrap {
  @media (max-width: 440px){
    flex-wrap: wrap;
    justify-content: center;
  }
}

.mobileAdjust {
  @media (max-width: 440px){
    width: 100%;
    justify-content: center;
    margin: 5px;
  }
}

.life-box {
  width: 75px;
    @media (max-width: 440px){
      width: 100%;
      justify-content: center;
      margin: 5px;
    }
  .life-item {
    margin-left: 5px;
      &:first-child {
        margin-left: 10px;
      }
  }
}

.used {
  filter: grayscale(.75);
}


.btn-transition {
  &-enter-active,
  &-leave-active {
    transition: opacity .2s;
  }
  &-enter,
  &-leave-to {
    opacity: 0;
  }
}

.container--unit {
    padding: 7px 13px;
    box-sizing: border-box;
    margin-top: 25px;
    position: relative;
    .container--unit__box {
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08), 0 6px 7px 0 rgba(0,0,0,0.04);
        border-radius: 20px;
        box-sizing: border-box;
        border: 2px solid rgb(82, 82, 82);
        text-align: center;
        transition: 0.3s;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:hover {
            transform: scale(1.06);
            background: #dfdfdf;
            box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.2);
        }
        .container--unit__title {
            font-size: 14px;
            text-align: center;
            color: #717171;
        }
        .container--unit__btn {
            margin: 5px 0px 10px 0px;
        }
        .container--unit__ball {
            width: 105px;
            height: 55px;
            margin-top: -20px;
            border-radius: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            text-align: center;
            // margin: 0 auto;
            // flex-direction: column;
            // position: relative;
            span {
                font-size: 15px;
                font-weight: 300
                // position: absolute;
                // top: 8px;
                // left: 0;
                // width: 100%;
                // text-align: center;
            }
            h3 {
                font-size: 40px;
                margin-left: 5px;
                font-weight: 400;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/virtualBooks/book.vue